import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
   
//import { CustomerClass } from '../../models/customer.class';
import { Customer } from '../../interfaces/customer.interface'; 
import { CustomerService } from "../../services/customer";
//import { SubsectorClass } from '../../models/subsector.class';
import { Subsector } from '../../interfaces/subsector.interface';
import { SubsectorService } from "../../services/subsector";
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-add-customer',
  imports: [ReactiveFormsModule],
  templateUrl: './add-customer.html',
  styleUrl: './add-customer.css'
})

export class AddCustomerComponent implements OnInit  {
  customers: Customer[] = [];
  subsectors: Subsector[] = [];
  submitted: boolean = false;
  myForm: FormGroup;

    //selectedCustomer: CustomerClass = [];
    //public customeradd: CustomerClass = [];
  model: any = {};

    //returnUrl: string;

  constructor(private customerService: CustomerService, 
              private subsectorService: SubsectorService, 
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                  customercode: new FormControl('',[Validators.maxLength(30)]),
                  customername: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
                  subsectorcode: new FormControl('', [Validators.required, Validators.maxLength(25)]),
                  origindate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  expirydate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  addressline1: new FormControl('', [Validators.required,Validators.minLength(3),Validators.maxLength(100)]),
                  addressline2: new FormControl('',[Validators.maxLength(100)]),
                  addresszip: new FormControl('',[Validators.required,Validators.maxLength(10)]),
                  phone: new FormControl('',[Validators.maxLength(25)]),
                  salesareacode: new FormControl('',[Validators.maxLength(100)]),
                  uploadSelected: new FormControl(true),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }


  get id() {
    return this.myForm.get('id');
  }
  get customercode() {
    return this.myForm.get('customercode');
  }
  get customername() {
    return this.myForm.get('customername');
  }
  get subsectorcode() {
    return this.myForm.get('subsectorcode');
  }
  get origindate() {
    return this.myForm.get('origindate');
  }
  get expirydate() {
    return this.myForm.get('expirydate');
  }
  get addressline1() {
    return this.myForm.get('addressline1');
  }
  get addressline2() {
    return this.myForm.get('addressline2');
  }
  get addresszip() {
    return this.myForm.get('addresszip');
  }
  get phone() {
    return this.myForm.get('phone');
  }  
  get salesareacode() {
    return this.myForm.get('salesareacode');
  }
   get uploaded() {
    return this.myForm.get('uploaded');
  }
    get uploadSelected() {
    return this.myForm.get('uploadedSelected');
  }

  async ngOnInit(): Promise<void> 
  {
    try 
    {
      this.subsectors = await this.subsectorService.getSubsector();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getsubsector',error);
    }
  }

  async addCustomer(): Promise<void>
  {
    // id
    // distid
    // uploaded
        var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";
      var customername = this.myForm.value.customername != null ? this.myForm.value.customername.trim() : "";
      var subsectorcode = this.myForm.value.subsectorcode != null ? this.myForm.value.subsectorcode.trim() : "";
      var origindate = this.myForm.value.origindate != null ? this.myForm.value.origindate.trim() : "";
      var expirydate = this.myForm.value.expirydate != null ? this.myForm.value.expirydate.trim() : "";
      var addressline1 = this.myForm.value.addressline1 != null ? this.myForm.value.addressline1.trim(): "";
      var addressline2 = this.myForm.value.addressline2 != null ? this.myForm.value.addressline2.trim() : "";
      var addresszip = this.myForm.value.addresszip != null ? this.myForm.value.addresszip.trim() : "";
      var phone = this.myForm.value.phone != null ? this.myForm.value.phone.trim() : "";
      var salesareacode = this.myForm.value.salesareacode != null ? this.myForm.value.salesareacode.trim() : "";
      var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";
      var uploadSelected = this.myForm.value.uploadSelected;

      //if (uploadSelected)
      //{
        uploaded = "0000-00-00";
      //}

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.customerService.create(customercode,customername,subsectorcode,origindate,expirydate,addressline1,addressline2,addresszip,phone,salesareacode,uploaded)
          this.cdr.detectChanges();
          this.router.navigateByUrl('customer'); 
        } catch (error) {
          console.error('createcustomer error',error);
        }

    

  }

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('customer');
  }
 
}
